var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VGridCol',{staticClass:"close_padding-y"},[_c('VButton',{staticClass:"button_space-y",attrs:{"loading":_vm.isLoading,"disabled":!_vm.description,"small":"","type":"button"},on:{"click":_vm.violationDone}},[_vm._v(" "+_vm._s(_vm.$t('page.close.done'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }